import logo from './logo.svg';
import './App.css';
import SpeechToText from './components/SpeechToText';
import SpeechToText2 from './components/SpeechToText2';
import SpeechToText3 from './components/SpeechToText3';

function App() {
  return (
    <div className="App">
       <SpeechToText />
       <SpeechToText2 />
       <SpeechToText3 />
    </div>
  );
}

export default App;
